import React from 'react'
import { withRouter } from 'react-router'
import './NotFound.scss'

function NotFound(props) {
  return (
    <div className='notFoundPage'>
        <div className='innerNotFoundpage'>
            <h2>
                404
                </h2>
            <h3>
                Oop's Something Went Wrong.
            </h3>
            <button onClick={()=>{
                props.history.push('/')
            }}>
                Go Back
            </button>
        </div>
    </div>
  )
}

export default withRouter(NotFound)